import { getFaireDirectBrandToken } from "@faire/retailer-visitor-shared/serialized-data/getFaireDirectBrandToken";
import find from "lodash/find";
var FAIRE_DIRECT_BRAND_DISCOUNT_TYPE = "ELEVATE_SIGNUP";
export var parseFaireDirectFirstOrderIncentiveFromBrandDiscounts = function(brandDiscounts) {
    var brandToken = getFaireDirectBrandToken();
    if (brandToken) {
        var discount = brandDiscounts[brandToken];
        if (discount && discount.type === FAIRE_DIRECT_BRAND_DISCOUNT_TYPE) {
            return discount;
        }
    }
    return find(brandDiscounts, function(discount) {
        return (discount === null || discount === void 0 ? void 0 : discount.type) === FAIRE_DIRECT_BRAND_DISCOUNT_TYPE;
    });
};
